import { c as _c } from "react/compiler-runtime";
import { useQuery } from '@apollo/client';
import { isNil, omitBy } from 'lodash';
import { GET_ACCOUNT_INFO } from '@/graphql/queries';
import { identifyFBUser } from 'commons/fbEvents';
import useIsBrowser from 'hooks/useIsBrowser';
import useUserLocation from 'global-state/userLocation/useUserLocation';
const useIdentifyFacebookUser = () => {
  const $ = _c(6);
  const isBrowser = useIsBrowser();
  const userLocation = useUserLocation();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      fetchPolicy: "network-only"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const userAccountInfo = useQuery(GET_ACCOUNT_INFO, t0);
  let t1;
  if ($[1] !== isBrowser || $[2] !== userAccountInfo?.phone || $[3] !== userAccountInfo?.phone2 || $[4] !== userLocation) {
    t1 = t2 => {
      const {
        email,
        firstName,
        lastName,
        userId
      } = t2;
      if (!isBrowser) {
        return;
      }
      const userDetails = omitBy({
        em: email,
        fn: firstName,
        ln: lastName,
        external_id: userId,
        ct: userLocation.city,
        st: userLocation.stateShortName,
        zp: userLocation.zip,
        country: userLocation.country,
        ph: userAccountInfo?.phone || userAccountInfo?.phone2
      }, isNil);
      identifyFBUser(userDetails);
    };
    $[1] = isBrowser;
    $[2] = userAccountInfo?.phone;
    $[3] = userAccountInfo?.phone2;
    $[4] = userLocation;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const identifyFacebookUser = t1;
  return identifyFacebookUser;
};
export default useIdentifyFacebookUser;